import { IFilter } from "../interfaces/IFilter";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const businessList = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/api/client/partner/business", { offset, filter });
};

export const businessGet = async (id: string) => {
  return httpRequest.get(`/api/client/partner/business/${id}`);
};
